import { AlertOctagon, ListChecks } from "lucide-react";

export const zeroLimit = (c) => !((c?.totals || {}).limit || {}).total;

// Limit Risk: toplam limiti 0 olan kartlar — bu firma/banka için yeni kredi veya teminat mektubu girilemez; "Limitleri Toplu Gir" → tek ekranda doldurma
export default function ZeroLimitAlert({ cards, canEdit, onBulk, onOpen }) {
  const zero = cards.filter(zeroLimit);
  if (!zero.length) return null;
  return (
    <div className="rounded-lg border border-red-300 bg-red-50/70 px-4 py-2.5 flex items-center gap-3 flex-wrap" data-testid="lr-zero-limit-alert">
      <AlertOctagon className="w-4 h-4 text-red-700 shrink-0" />
      <span className="text-sm font-bold text-red-800" data-testid="lr-zero-limit-count">{zero.length} kartın limiti 0</span>
      <span className="text-[11px] text-red-700/90">— limit girilmeden bu banka/firma için yeni kredi veya teminat mektubu kabul edilmez:</span>
      <span className="flex items-center gap-1 flex-wrap">
        {zero.map((c) => (
          <button key={c.id} type="button" onClick={() => onOpen(c)} data-testid={`lr-zero-limit-${c.id}`} title="Karta git" className="px-1.5 py-0.5 rounded border border-red-300 bg-white text-[11px] font-semibold text-red-800 hover:bg-red-100">{c.bank} · {c.company}</button>
        ))}
      </span>
      {canEdit && <button type="button" onClick={() => onBulk(zero.map((c) => c.id))} data-testid="lr-zero-limit-bulk" className="ml-auto inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-red-700 text-white text-xs font-semibold hover:bg-red-800"><ListChecks className="w-3.5 h-3.5" /> Limitleri Toplu Gir</button>}
    </div>
  );
}
